import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';

import packageJson from '../../package.json';
import { useAppDispatch } from '../app/hook';
import { AuthRTKService } from '../app/services/auth-rtk.service';
import { BillingRTKService } from '../app/services/billing-rtk.service';
import { ChatbotRTKService } from '../app/services/chatbot-rtk.services';
import { resetStore } from '../app/store';
import { MultiLanguageUrl } from '../constants/multiLanguage.constant';
import { handleResetAppearance } from '../features/appearance/appearanceSlice';
import { logout } from '../features/auth/auth.slice';
import { handleResetWizard } from '../features/bot/botSlice';
import { resetDashboard } from '../features/dashboard.slice';
import { resetCreate, resetPackage } from '../features/knowledge.slice';
import useAuth from './useAuth';

const useVersion = () => {
  const { i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const auth = useAuth();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  useEffect(() => {
    const version = localStorage.getItem(`LOUISEBOT_version`);
    if (version && version != '' && version != packageJson.version) {
      if ('caches' in window) {
        caches.keys().then(names => {
          // Delete all the cache files
          names.forEach(name => {
            caches.delete(name);
          });
        });
      }

      localStorage.removeItem(`LOUISEBOT_service`);

      localStorage.removeItem(`LOUISEBOT_token`);

      localStorage.removeItem(`LOUISEBOT_user_access_token`);

      localStorage.clear();

      localStorage.setItem(`LOUISEBOT_version`, packageJson.version);

      resetStore().then(() => {
        auth.logout();

        queryClient.clear();

        dispatch(AuthRTKService.util.resetApiState());
        dispatch(BillingRTKService.util.resetApiState());
        dispatch(ChatbotRTKService.util.resetApiState());

        dispatch(resetDashboard());
        dispatch(resetCreate());
        dispatch(resetPackage());
        dispatch(handleResetWizard());
        dispatch(handleResetAppearance());
        dispatch(logout());

        if (location?.href?.includes('register')) {
          navigate(`/${MultiLanguageUrl[i18n.language] || 'en-US'}/register`);
        }

        navigate(`/${MultiLanguageUrl[i18n.language] || 'en-US'}`);

        window.location.reload();
      });
    }
  }, [window.location.pathname]);
};

export default useVersion;
